import React, { useState, useMemo, useEffect } from "react";
import {
  Modal,
  Box,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  Checkbox,
  FormControlLabel,
  InputAdornment,
  Chip,
  Grid,
  Typography,
  Dialog,
} from "@mui/material";
import { CloseOutlined, Search, AccessTime, CheckCircleOutlined } from "@mui/icons-material";
import { CustomizeTextField, style } from "../templates/TemplateTable";
import useAuthFetch from "../../hooks/useAuthFetch";
import toast from "react-hot-toast";

const VCActionsModal = ({ defaultUtility, setOpenErr, setErrMsg }) => {
  const customFetch = useAuthFetch();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [selectedApps, setSelectedApps] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [triggerText, setTriggerText] = useState(false);
  const [timestamp, setTimestamp] = useState("");
  const [executionResult, setExecutionResult] = useState(null);

  const [minutes, setMinutes] = useState("");
  const [seconds, setSeconds] = useState("");
  const [localError, setLocalError] = useState("");

  const [selectedUtility, setSelectedUtility] = useState(defaultUtility);
  const [endpointType, setEndpointType] = useState(defaultUtility);

  useEffect(() => {
    setEndpointType(selectedUtility);
  }, [selectedUtility]);

  useEffect(() => {
    if (defaultUtility) {
      setSelectedUtility(defaultUtility);
      setEndpointType(defaultUtility);
      setSelectedApps([]);
      setSearchTerm("");
      setMinutes("");
      setSeconds("");
    }
  }, [defaultUtility]);


  const handleOpen = () => {
    setSelectedUtility(defaultUtility);
    setEndpointType(defaultUtility);
    setSelectedApps([]);
    setSearchTerm("");
    setMinutes("");
    setSeconds("");
    setOpen(true);
  };


  const handleClose = () => {
    setOpen(false);
    setEndpointType("");
    setSelectedApps([]);
    setSearchTerm("");
    setTriggerText(false);
    setMinutes("");
    setSeconds("");
    setTimestamp("");
  };


  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (searchTerm.length >= 7) {
        fetchApplications();
      } else {
        setSearchResults([]);
      }
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [searchTerm]);

  const fetchApplications = async () => {
    try {
      const url = `${process.env.REACT_APP_API_URL}/v1/dashboard/journey/searchByApplicationNumber`
      const body = {
        applicationNo: searchTerm,
      };
    
      const { response, status } = await customFetch(url, "POST", JSON.stringify(body));
      if (status === 200) {
        setSearchResults(response.data || []);
      }
    } catch (error) {
      console.error("Search failed", error);
    }
  };

  const filteredJourneys = useMemo(() => {
    return searchResults;
  }, [searchResults]);

  const toggleSelection = (appNo) => {
    setSelectedApps([appNo]);
    setSearchTerm("");
  };

  const removeSelected = (appNo) => {
    setSelectedApps((prev) => prev.filter((id) => id !== appNo));
  };
  const validateForm = () => {


    if (endpointType === "directDB") {
      if (minutes === "" || seconds === "") {
        toast.error("Please enter both minutes and seconds");
        return false;
      }
      const secs = parseInt(seconds);
      if (secs < 0 || secs > 59) {
        toast.error("Seconds must be between 0 and 59");
        return false;
      }
    }
    return true;
  };
  const utilityLabels = {
    "CIN": "Update Customer Image",
    "NJS": "Update Journey Screenshots",
    "UPDF": "Update Customer PDF",
    "direct-DB": "Update Customer Image (Direct)",
    "Video-Restore": "Restore PIVV Video",
    "PDF-Restore": "Restore PIVV PDF",
    "kypSync": "KYP Status"
  };
  const handleSubmit = async () => {
    if (!validateForm()) return;
    if (!endpointType || selectedApps.length === 0) {
      toast.error("Please select an action and at least one application");
      return;
    }
    setLoading(true);
    let urlPath = "";
    let bodyContent = {};
    const currentApp = selectedApps[0];
    const formattedTimestamp = parseFloat(`${minutes}.${seconds.padStart(2, '0')}`);

    switch (endpointType) {
      case "CIN":
        urlPath = "/vidassure/CIN/run_CIN";
        bodyContent = {
          application_numbers: [currentApp],
          trigger_text: triggerText,
        };
        break;
      case "NJS":
        urlPath = "/vidassure/NJS/run_NJS";
        bodyContent = { application_numbers: [currentApp] };
        break;
      case "UPDF":
        urlPath = "/vidassure/UPDF/run_UPDF";
        bodyContent = { application_numbers: [currentApp] };
        break;
      case "kypSync":
        urlPath = "/v1/dashboard/resyncfileuploads";
        bodyContent = { applicationNo: currentApp };
        break;
      case "PDF-Restore":
        urlPath = "/v1/dashboard/getRestoreS3Object";
        bodyContent = { applicationNo: currentApp, type: 'pdf' };
        break;
      case "Video-Restore":
        urlPath = "/v1/dashboard/getRestoreS3Object";
        bodyContent = { applicationNo: currentApp, type: 'recording' };
        break;
      case "direct-DB":
        urlPath = "/vidassure/directDB/run_directDB";
        bodyContent = {
          application_number: currentApp,
          time: formattedTimestamp,
        };
        break;
      default:
        break;
    }
    try {
      const url = new URL(`${process.env.REACT_APP_API_URL}${urlPath}`);
      const method = "POST";
      const { response, status, message } = await customFetch(
        url,
        method,
        bodyContent
      );


      if (status === 200) {
        setExecutionResult(response.result);
        const failedList = response?.result?.failed || [];
        // console.log("Success Data:", response.error);
        // console.log("Success message:", message);
        // console.log("failedList message:", failedList);

        toast.success(response.message || "Action processed successfully!");
        // toast.success(response.message ?? "Action processed successfully!");

        // handleClose();
      }
      else {
        console.log("failure Data:", response);
        setOpenErr(true);
        // toast.error(message || "Pipeline execution failed");
        const errorMsg = response?.error || message || "Pipeline execution failed";

        if (status === 400) {
          toast.error(`Bad Request: ${errorMsg}`);
        } else if (status === 403) {
          toast.error(`Access Denied: ${errorMsg}`);
        } else {
          toast.error(errorMsg);
        }
      }
    } catch (error) {
      toast.error("Network error or invalid response");
      setOpenErr(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>

      <button
        onClick={handleOpen}
        className="group flex items-center justify-center bg-blue-600 text-white 
             rounded-md p-2.5 
             hover:border-gray-400 border border-transparent
             transition-all duration-300 ease-in-out hover:px-4 shadow-sm"
      >
        <svg
          xmlns="http://w3.org"
          width="18" height="18"
          viewBox="0 0 24 24" fill="none" stroke="currentColor"
          strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"
        >
          <polygon points="5 3 19 12 5 21 5 3" />
        </svg>

        <span className="max-w-0 overflow-hidden whitespace-nowrap text-[10px] font-bold uppercase tracking-widest 
                   transition-all duration-300 ease-in-out group-hover:max-w-[100px] group-hover:ml-2">
          Run Action
        </span>
      </button>


      <Dialog open={open}
        onClose={handleClose}
        closeAfterTransition={false}>
        <Modal open={open} onClose={handleClose}>
          <Box sx={{ ...style, width: 600 }} className="rounded-xl relative">
            <button
              className="absolute top-2 right-3"
              onClick={() => {
                setExecutionResult(null);
                handleClose();
              }}
            >
              <CloseOutlined className="w-5 h-5 text-gray-450" />
            </button>
            {executionResult ? (
              <div className="animate-in fade-in duration-500">
                <p className="text-2xl font-extrabold text-center mb-6">Action Summary</p>



                {endpointType === "directDB" ? (
                  <div className="">

                    {executionResult.success ? (
                      <div className="bg-green-50 p-6 rounded-xl border border-green-100 text-center mb-8">

                        <div className="text-center">
                          <div className="flex justify-center mb-2">
                            <CheckCircleOutlined className="text-green-600 w-12 h-12" />
                          </div>
                          <p className="text-green-800 font-bold text-lg">
                            {executionResult.success}
                          </p>
                        </div>
                      </div>

                    ) : (
                      <div className="bg-red-50 p-6 rounded-xl border border-green-100 text-center mb-8">

                        <div className="text-center">
                          <div className="flex justify-center mb-2">
                            <CloseOutlined className="text-red-600 w-12 h-12" />
                          </div>
                          <p className="text-red-800 font-bold text-lg">
                            {executionResult.error}
                          </p>
                        </div>
                      </div>
                    )}


                  </div>
                ) : (
                  <>

                    {executionResult.error ? (
                      <div className="bg-red-50 p-6 rounded-xl border border-red-200 text-center mb-8">
                        <div className="flex justify-center mb-2">
                          <CloseOutlined className="text-red-600 w-12 h-12" />
                        </div>
                        <p className="text-red-800 font-bold text-lg">
                          {executionResult.error}
                        </p>
                      </div>
                    ) : (
                      <>
                        <div className="grid grid-cols-3 gap-4 mb-8">
                          <div className="p-4 rounded-xl border text-center">
                            <p className="text-green-600 text-xs font-bold uppercase tracking-wider">Completed</p>
                            <p className="text-3xl font-black text-green-700">{executionResult.completed?.length || 0}</p>
                          </div>
                          <div className="p-4 rounded-xl border text-center">
                            <p className="text-blue-600 text-xs font-bold uppercase tracking-wider">Uploaded</p>
                            <p className="text-3xl font-black text-blue-700">{executionResult.uploaded?.length || 0}</p>
                          </div>
                          <div className="p-4 rounded-xl border text-center">
                            <p className="text-red-700 text-xs font-bold uppercase tracking-wider">Failed</p>
                            <p className="text-3xl font-black text-red-700">{executionResult.failed?.length || 0}</p>
                          </div>
                        </div>

                        {executionResult.failed?.length > 0 && (
                          <div className="mb-6">
                            <p className="text-sm font-bold text-gray-700 mb-2">Failed Application Numbers:</p>
                            <div className="bg-gray-50 border rounded-lg p-3 max-h-40 overflow-y-auto">
                              <div className="flex flex-wrap gap-2">
                                {executionResult.failed.map((id) => (
                                  <span key={id} className="px-3 py-1 rounded-full text-base font-bold shadow-sm">
                                    {id}
                                  </span>
                                ))}
                              </div>
                            </div>
                          </div>
                        )}
                        {executionResult.uploaded?.length > 0 && (
                          <div className="mb-6">
                            <p className="text-sm font-bold text-gray-700 mb-2">Uploaded Application Numbers:</p>
                            <div className="bg-gray-50 border rounded-lg p-3 max-h-40 overflow-y-auto shadow-inner">
                              <div className="flex flex-wrap gap-2">
                                {executionResult.uploaded.map((id) => (
                                  <span key={id} className="bg-white px-3 py-1 rounded-full text-base font-bold border border-red-200 shadow-sm">
                                    {id}
                                  </span>
                                ))}
                              </div>
                            </div>
                          </div>
                        )}


                      </>

                    )}
                  </>

                )}
                <div className="flex gap-3">
                  <button
                    onClick={() => setExecutionResult(null)}
                    className="flex-1 py-3 border-2 border-blue-600 text-blue-600 font-bold rounded-lg hover:bg-blue-50 transition-all rgb(255 255 255 / var(--tw-text-opacity, 1))"
                  >
                    Run Another
                  </button>
                  <button
                    onClick={() => {
                      setExecutionResult(null);
                      handleClose();
                    }}
                    className="flex-1 py-3 bg-blue-600 text-white font-bold rounded-lg hover:bg-blue-700 shadow-lg transition-all"
                  >
                    Close
                  </button>
                </div>
              </div>
            ) : (
              <>
                <p className="text-2xl font-extrabold text-center mb-6">
                  Utility  - {utilityLabels[selectedUtility]}
                </p>
                <FormControl fullWidth className="mb-4" style={{ display: defaultUtility ? 'none' : 'block' }} >
                  {/* <InputLabel>Select Action Type</InputLabel> */}
                  <Select
                    value={selectedUtility}
                    onChange={(e) => {
                      const val = e.target.value;
                      setSelectedUtility(val);
                      setEndpointType(val);
                    }}
                  >
                    <MenuItem value="CIN">Update Customer Image</MenuItem>
                    <MenuItem value="NJS">Update Journey Screenshots</MenuItem>
                    <MenuItem value="UPDF">Update Customer PDF</MenuItem>
                    <MenuItem value="direct-DB">Update Customer Image (Direct)</MenuItem>
                    <MenuItem value="Video-Restore">Restore PIVV Video</MenuItem>
                    <MenuItem value="PDF-Restore">Restore PIVV PDF</MenuItem>
                    <MenuItem value="kypSync">KYP Sync</MenuItem>
                  </Select>
                </FormControl>
                {endpointType && (
                  <div className="mt-4 space-y-4">
                    {selectedApps.length > 0 && (
                      <div className="flex flex-wrap gap-2 p-2 border rounded-md bg-blue-50/30 max-h-[100px] overflow-y-auto">
                        <span className="text-xs font-bold text-blue-600 w-full mb-1">
                          Current Selection:
                        </span>
                        {selectedApps.map((app) => (
                          <Chip
                            key={app}
                            label={app}
                            size="small"
                            onDelete={() => removeSelected(app)}
                            color="primary"
                            variant="outlined"
                            className="bg-white"
                          />
                        ))}
                      </div>
                    )}
                    {selectedApps.length === 0 && (
                      <CustomizeTextField
                        fullWidth
                        autoFocus
                        variant="outlined"
                        placeholder="Search Application No to add..."
                        className="bg-[#F3F4F8] text-black w-full rounded-lg" // Applied CSS
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Search />
                            </InputAdornment>
                          ),
                        }}
                      />)}
                    {searchTerm.trim() !== "" && (
                      <div className="border rounded-lg max-h-[200px] overflow-y-auto bg-white shadow-inner">
                        {filteredJourneys.length > 0 ? (
                          filteredJourneys.map((item) => (
                            <div
                              key={item.applicationNo}
                              onClick={() => {
                                toggleSelection(item.applicationNo);
                                if (endpointType === "directDB") setSearchTerm(""); // Clear search on single select
                              }}
                              className={`flex items-center p-3 border-b cursor-pointer hover:bg-gray-50 transition-colors
                          ${selectedApps.includes(item.applicationNo)
                                  ? "bg-blue-50"
                                  : ""
                                }
                        `}
                            >
                              <Checkbox
                                checked={selectedApps.includes(item.applicationNo)}
                                size="small"
                              />
                              <div className="ml-2">
                                <p className="text-sm font-bold mb-0">
                                  {item.applicationNo}
                                </p>
                                <p className="text-xs text-gray-500 mb-0">
                                  Status: {item.journeyStatus}
                                </p>
                              </div>
                            </div>
                          ))
                        ) : (
                          <p className="p-4 text-center text-gray-400 text-sm italic">
                            No matching applications found
                          </p>
                        )}
                      </div>
                    )}
                    {!searchTerm && selectedApps.length === 0 && (
                      <p className="text-center text-gray-400 text-sm py-4">
                        Type an application number above to start selection
                      </p>
                    )}
                    <div className="flex flex-col gap-2 pt-2">
                      {endpointType === "CIN" && (
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={triggerText}
                              onChange={(e) => setTriggerText(e.target.checked)}
                              color="primary"
                            />
                          }
                          label={
                            <span className="text-sm font-medium text-gray-700">
                              Enable Trigger Text
                            </span>
                          }
                        />
                      )}
                      {endpointType === "direct-DB" && (
                        <div className="p-4 border rounded-lg bg-gray-50">
                          <Typography variant="subtitle2" className="mb-2 flex items-center gap-1 text-gray-700">
                            <AccessTime sx={{ fontSize: 18 }} /> Target Frame Timestamp
                          </Typography>
                          <Grid container spacing={2} alignItems="center">
                            <Grid item xs={5}>
                              <CustomizeTextField
                                fullWidth
                                label="Minutes"
                                type="number"
                                placeholder="MM"
                                value={minutes}
                                onChange={(e) => {
                                  const val = e.target.value.replace(/\D/g, "");
                                  if (val === "" || (parseInt(val) >= 0 && parseInt(val) <= 59)) {
                                    setMinutes(val);
                                  }
                                }}
                              />
                            </Grid>
                            <Grid item xs={2} className="text-center font-bold text-xl"> : </Grid>
                            <Grid item xs={5}>
                              <CustomizeTextField
                                fullWidth
                                label="Seconds"
                                type="number"
                                placeholder="SS"
                                value={seconds}
                                onChange={(e) => {
                                  const val = e.target.value.replace(/\D/g, "");
                                  if (val === "" || (parseInt(val) >= 0 && parseInt(val) <= 59)) {
                                    setSeconds(val);
                                  }
                                }}
                              />
                            </Grid>
                          </Grid>
                          <p className="text-[10px] text-gray-500 mt-2">
                            Format: {minutes || "0"}.{seconds.padStart(2, "0") || "00"} (Minutes.Seconds)
                          </p>
                        </div>
                      )}
                    </div>
                    <button
                      disabled={loading || selectedApps.length === 0}
                      className={`w-full py-3 text-white font-bold rounded-lg mt-4 shadow-md transition-all ${loading || selectedApps.length === 0
                        ? "bg-gray-400"
                        : "bg-blue-600 hover:bg-blue-700"
                        }`}
                      onClick={handleSubmit}
                    >
                      {loading ? (
                        "Processing..."

                      )
                        : (`Run Action on ${selectedApps.length} App(s)`)
                      }
                    </button>
                  </div>
                )}
              </>
            )}
          </Box>
        </Modal>
      </Dialog>

    </>

  );
};
export default VCActionsModal;
